import { service } from "@/api/service ";
import { toastError, toast } from "@/components/custom/Toast";
import store from "../..";

const state = {
  users: [],
  user: {},
  roles: [],
  pagination: {},
  addStatus: false,
  editStatus: false,
  deleteStatus: false,
};
// const getters = {
//   attendenceTemplateListGet: (state) =>
//     state.attendenceTemplates.map((obj) =>
//       obj.isActive == 1
//         ? { ...obj, isActive: "active" }
//         : { ...obj, isActive: "notActive" }
//     ),
//   attendenceTemplateGet: (state) => state.attendenceTemplate,
//   paginationGet: (state) => state.pagination,
// };
const getters = {
  usersListGet: (state) => state.users,
  // .map((obj) =>
  // obj.is_blocked == 1
  //   ? { ...obj, is_blocked: "blocked" }
  //   : { ...obj, is_blocked: "active" }
  // rolesListGet: (state) => state.roles,
  userGet: (state) => state.user,
};
const actions = {
  getUsers({ commit }, payload) {
    let page = payload.isModal ? 0 : store.state.page.page;
    service.getFun(`/users?page=${page}`).then(
      (obj) => {
        var result = obj?.data?.data;
        const pageresult = {
          currentPage: obj?.data?.current_page,
          lastPage: obj?.data?.last_page,
          itemsPerPage: obj?.data?.per_page,
          total: obj?.data?.total,
        };
        commit("setPagination", pageresult);
        commit("usersListSet", result);
      },
      (error) => {
        console.log("users..." + error);
        toastError(error);
      }
    );
  },
  // getRoles({ commit }, payload) {
  //   let page = payload.isModal ? 0 : store.state.page.page;
  //   service.getFun(`get-roles?page=${page}`).then(
  //     (obj) => {
  //       var result = obj.data;
  //       commit("rolesListSet", result);
  //     },
  //     (error) => {
  //       console.log("roles..." + error);
  //       toastError(error);
  //     }
  //   );
  // },
  addUser({ commit }, payload) {
    service
      .postFun(service.deleteNullValues(payload), `users`, null, {
        action: "getUsers",
      })
      .then(
        (result) => {
          commit("addUserStatus", result.success);
          toast(result.message);
        },
        (error) => {
          console.log("courses..." + error);
          toastError(error);
        }
      );
  },
  getUserByIdFun({ commit }, payload) {
    service.getFun(`users/${payload.id}`).then(
      (obj) => {
        var result = obj?.data;
        commit("getUserById", result);
        // console.log(result, "result");
      },
      (error) => {
        toastError(error);
      }
    );
  },

  editUser({ commit }, payload) {
    console.log(payload, "'payload update'");
    service
      .postFun(service.deleteNullValues(payload), `users/${payload.id}`, null, {
        action: "getUsers",
      })
      .then(
        (result) => {
          commit("editUserStatus", result?.success);
          console.log(result);
          toast(result?.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
  deleteUser({ commit }, payload) {
    service
      .postFun(null, `users/delete/${payload.payload}`, null, {
        action: "getUsers",
      })
      .then(
        (result) => {
          commit("deleteUserStatus", result.success);
          toast(result.message);
        },
        (error) => {
          toastError(error);
        }
      );
  },
};
const mutations = {
  usersListSet(state, users) {
    state.users = users;
  },
  // rolesListSet(state, roles) {
  //   state.roles = roles;
  // },
  getUserById(state, user) {
    state.user = user;
  },
  addUserStatus(state, Status) {
    state.addStatus = Status;
  },
  editUserStatus(state, Status) {
    state.editStatus = Status;
  },
  deleteUserStatus(state, Status) {
    state.deleteStatus = Status;
  },
  setPagination(state, pageResult) {
    state.pagination = pageResult;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
